import { render, staticRenderFns } from "./foreign-company-type.vue?vue&type=template&id=e170b2aa&"
import script from "./foreign-company-type.vue?vue&type=script&lang=js&"
export * from "./foreign-company-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports